import { Keys, LogLevel, NbLogger } from '@eih-netbroker/common';
import { IDBPObjectStore } from 'idb';
import { nanoid } from 'nanoid';
import { Config } from '../config/config';
import { IDB } from './idb';
import { CookieUtils } from './useCookie';

export class AppLogLogger extends IDB {
  static storeName = 'appLog';
  private static instance: AppLogLogger;

  static async clearDb() {
    const instance = new AppLogLogger(AppLogLogger.storeName);
    await instance.create();
    await instance.delete();
  }

  static async getInstance() {
    if (!AppLogLogger.instance) {
      AppLogLogger.instance = new AppLogLogger(AppLogLogger.storeName);
      await AppLogLogger.instance.create();
    }
    return AppLogLogger.instance;
  }

  static getLogger(): ((message: any) => void) | null {
    const enabled = !!CookieUtils.getCookie(Keys.Cookie.AppLog);
    if (!enabled) {
      return null;
    }

    if (!AppLogLogger.instance) {
      AppLogLogger.instance = new AppLogLogger(AppLogLogger.storeName);
      AppLogLogger.instance.create();
    }
    return AppLogLogger.instance.log.bind(AppLogLogger.instance);
  }

  async filterByDate(from: Date, to: Date) {
    if (!this.db) {
      throw new Error('Database not initialized');
    }
    const tx = this.db?.transaction(`store`, 'readwrite');
    if (!tx) {
      throw new Error('Failed to create transaction');
    }

    const dateRange = IDBKeyRange.bound(from, to);
    const index = tx.store.index('timestamp');
    return await index.getAll(dateRange);
  }

  override setupIndexes(store: IDBPObjectStore<any, any, `store`, 'versionchange'>) {
    super.setupIndexes(store);
    store.createIndex('level', 'level');
    store.createIndex('timestamp', 'timestamp');
    store.createIndex('origin', 'origin');
  }
}

const logCallback = AppLogLogger.getLogger();

class NbLoggerWeb extends NbLogger {
  constructor(name: string, level: LogLevel = 'debug') {
    super(name, level, Config.App.EnableAppDebugger);
  }

  protected logEvent(level: LogLevel, origin: string, message?: any, ...optionalParams: any[]) {
    if (!logCallback) {
      return;
    }
    try {
      logCallback({ id: nanoid(), level, timestamp: new Date(), origin, message, optionalParams });
    } catch (err) {
      console.error(`Failed to log event`, err);
    }
  }
}

export const createLogger = (name: string, level: LogLevel = 'debug') => {
  return new NbLoggerWeb(name, level);
};
